import React,{useState,useEffect} from 'react';
import {Link,useNavigate} from 'react-router-dom';
import Loader from "../../components/Loader.js";
import { useDispatch, useSelector } from "react-redux";
import { useAlert } from "react-alert";
import { clearErrors, register } from "../../actions/userAction";
import {AiFillEye,AiOutlineEyeInvisible} from "react-icons/ai";
import ReCAPTCHA from "react-google-recaptcha";

const Register = () => {

    const [captchaValidated, setCaptchaValidated] = useState(false); // CAPTCHA validation state
    const [showpassword, setShowPassword] = useState(false);
    const togglePassword = () =>{
        setShowPassword(!showpassword);
    }

    const dispatch = useDispatch();
    const alert = useAlert();
    const navigate = useNavigate();

    const { error, loading, isAuthenticated } = useSelector((state) => state.user);

    // const [user, setUser] = useState({
    //     name: "",
    //     email: "",
    //     password: "",
    // });

    // const { name, email, password } = user;
    const [name, setName] = useState("");
    const [lname, setLName] = useState("");
    const [mob, setMob] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [images, setImages] = useState("/Profile.png");
    const [imagesPreview, setImagesPreview] = useState("/Profile.png");

    // const registerDataChange = (e) => {
    //     const fileList = e.target.files;
    //     setImages(fileList);
    // };

    const registerDataChange = (e) => {
        const fileList = Array.from(e.target.files); // Convert FileList to an array
        setImages(fileList); // Store File objects for FormData

        const previews = fileList.map((file) => URL.createObjectURL(file));
        setImagesPreview(previews); // Separate state for previews
    };


    const registerSubmit = (e) => {
        e.preventDefault();

        if (!captchaValidated) {
          alert.error("Please complete the CAPTCHA to proceed.");
          return;
        }

        const myForm = new FormData();
        
        for (let i = 0; i < images.length; i++) {
          myForm.append('images', images[i]);
        }

        myForm.set("name", name);
        myForm.set("lname", lname);
        myForm.set("mob", mob);
        myForm.set("email", email);
        myForm.set("password", password);
        // myForm.set("avatar", avatar);
        dispatch(register(myForm));
    };

    useEffect(() => {
        if (error) {
          alert.error(error);
          dispatch(clearErrors());
        }

        if (isAuthenticated) {
            navigate('/account');
        }

    }, [dispatch, isAuthenticated, error, alert, navigate]);

    function onCaptchaChange(value) {
        if (value) {
          setCaptchaValidated(true);
        } else {
          setCaptchaValidated(false);
        }
      }

	return (
		<>

        {loading ? (
        <Loader />
      ) : (
      <>
			{/*<!-- Register Section Start -->*/}
    <div className="section section-padding login-register-panel">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-6 col-md-6 col-sm-12">
                    {/*<!-- Login & Register Start -->*/}
                    <div className="login-register-wrapper">
                        <h4 className="title">Register Your Account</h4>
                        <form onSubmit={registerSubmit}>
                            <div className="single-form" id="registerImage">
                                <img src={imagesPreview} alt="Avatar Preview" />
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={registerDataChange}
                                    multiple={true}
                                  />
                            </div>
                            <div className="single-form">
                                <input type="text" placeholder="First Name" name="name" value={name} onChange={(e) => setName(e.target.value)}/>
                            </div>
                            <div className="single-form">
                                <input type="text" placeholder="Last Name" name="lname" value={lname} onChange={(e) => setLName(e.target.value)}/>
                            </div>
                            <div className="single-form">
                                <input type="text" placeholder="Phone Number" name="mob" value={mob} onChange={(e) => setMob(e.target.value)}/>
                            </div>
                            <div className="single-form">
                                <input type="email" placeholder="Email *" name="email" value={email} onChange={(e) => setEmail(e.target.value)}/>
                            </div>
                            {/*<div className="single-form">
                                <input type="text" placeholder="Username *" />
                            </div>*/}
                            <div className="single-form">
                            {/*<div className="passwordField">
                                <AiFillEye />
                                <input type="password" placeholder="Password" name="password" value={password} onChange={registerDataChange}/>
                            </div>*/}
                            <div className="passwordField">
                                <input type={showpassword ? 'text' : 'password'} name="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
                                <div className="password_icon" onClick={togglePassword}>
                                    {showpassword ? (<AiOutlineEyeInvisible size={20} />) : (<AiFillEye size={20}/>)}
                                </div>
                            </div>
                            </div>
                            {/*<div className="single-form">
                                <input type="password" placeholder="Confirm Password" />
                            </div>*/}
                            <div className="single-form">
                            <ReCAPTCHA
                                sitekey="Your client site key"
                                onChange={onCaptchaChange}
                            />
                            </div>
                            <div className="single-form">
                                <button type="submit" className="btn btn-primary btn-hover-dark">
                                    Register
                                </button>
                            </div>
                            <p>
	                            Already have an account?
	                            <Link to="/login">Log in instead!</Link>
	                        </p>
                        </form>
                    </div>
                    {/*<!-- Login & Register End -->*/}
                </div>
            </div>
        </div>
    </div>
    {/*<!-- Register Section End -->*/}	
    </>
        )}
		</>
	)
}

export default Register